module.exports = __webpack_public_path__ + "a17d279f/img/send-icon.3cfb6275.svg";